import React from 'react';
import { FormattedMessage } from 'react-intl';

// convert display info booleans into type strings
// so that messages can use select
export const getPriceMessagesTypes = pricingDisplayInfo => {
    // for onHoldLabel message
    let holdType;
    if (pricingDisplayInfo.showOnHoldCustom) {
        holdType = 'ON_HOLD_CUSTOM';
    } else if (pricingDisplayInfo.showOnHold) {
        holdType = 'ON_HOLD';
    }

    // for textPriceValue && priceLabel messages
    let textPriceType;
    if (pricingDisplayInfo.showSold) {
        textPriceType = 'sold';
    } else if (pricingDisplayInfo.showUnavailable) {
        textPriceType = 'unavailable';
    } else if (pricingDisplayInfo.showPUR) {
        textPriceType = 'pur';
    }

    return { holdType, textPriceType };
};

export const onHoldLabel = holdType => (
    <FormattedMessage
        values={{ holdType }}
        id="priceMessages.onHoldLabel"
        defaultMessage={`{holdType, select,
                ON_HOLD {On Hold}
                ON_HOLD_CUSTOM {On Hold For You}
                other {On Hold}
            }`}
    />
);

export const textPriceValue = textPriceType => (
    <FormattedMessage
        values={{ textPriceType }}
        id="priceMessages.textPriceValue"
        defaultMessage={`{textPriceType, select,
            sold {Sold}
            unavailable {Unavailable}
            pur {Price Upon Request}
            other {Sold}
        }`}
    />
);

export const priceLabel = type => (
    <FormattedMessage
        values={{ type }}
        id="priceMessages.label"
        defaultMessage={`{type, select,
            NET {Net Price}
            RETAIL {List Price}
            PRIVATE_OFFER {Private Offer}
            other {List Price}
        }`}
    />
);

export const discountLabel = discount => (
    <FormattedMessage
        values={{ discount }}
        id="priceMessages.discount"
        defaultMessage="{discount}% Off"
    />
);
